/* Dizzplace - konfigurator zestawu probek (Figma 855:6650).

   Zestaw jest JEDNA pozycja koszyka: wariant produktu-nosnika odpowiada
   liczbie wybranych wzorow, a same wzory jada jako wlasciwosci pozycji.
   Dzieki temu kwota na przycisku jest ta sama, ktora policzy koszyk - cennik
   z projektu ("5. gratis") siedzi w cenach wariantow, nie w skrypcie. */
(() => {
  const formatujKwote = (grosze, format) => {
    const kwota = (grosze / 100).toFixed(2);
    const [calosc, ulamek] = kwota.split('.');
    const zSpacja = calosc.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    const warianty = {
      amount: `${zSpacja}.${ulamek}`,
      amount_no_decimals: zSpacja,
      amount_with_comma_separator: `${calosc.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${ulamek}`,
      amount_no_decimals_with_comma_separator: calosc.replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
      amount_with_space_separator: `${zSpacja},${ulamek}`,
      amount_no_decimals_with_space_separator: zSpacja,
      amount_with_apostrophe_separator: `${calosc.replace(/\B(?=(\d{3})+(?!\d))/g, "'")}.${ulamek}`,
    };

    if (!format) return warianty.amount_with_comma_separator;
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, klucz) =>
      Object.prototype.hasOwnProperty.call(warianty, klucz) ? warianty[klucz] : ''
    );
  };

  const czytajJson = (root, selektor, zapas) => {
    const el = root.querySelector(selektor);
    if (!el) return zapas;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return zapas;
    }
  };

  const initSampleSet = (root) => {
    if (root.dataset.gotowe === 'true') return;
    root.dataset.gotowe = 'true';

    const maks = parseInt(root.dataset.max, 10) || 0;
    const warianty = czytajJson(root, '[data-set-variants]', []);
    const napisy = czytajJson(root, '[data-set-copy]', {});

    const kafelki = Array.from(root.querySelectorAll('[data-sample-tile]'));
    const sloty = Array.from(root.querySelectorAll('[data-slot]'));
    const polaWariantu = root.querySelector('[data-set-variant]');
    const przycisk = root.querySelector('[data-set-submit]');
    const napisPrzycisku = root.querySelector('[data-submit-label]');
    const plakietka = root.querySelector('[data-count-badge]');
    const stan = root.querySelector('[data-count-state]');
    const cena = root.querySelector('[data-count-price]');
    const pas = root.querySelector('[data-sample-note]');
    const pasTytul = root.querySelector('[data-note-title]');
    const pasTresc = root.querySelector('[data-note-text]');
    const wiecej = root.querySelector('[data-sample-more]');
    const krotkiStan = root.querySelector('[data-slots-count]');

    if (!sloty.length) return;

    /* Stan zestawu: jeden wpis na slot, null gdy pusty. */
    const wybor = new Array(sloty.length).fill(null);

    /* Wzory, ktore sa juz w jakims zestawie w koszyku (z /cart.js). Na liscie
       w okienku dostaja dopisek, ale DA SIE je wybrac - drugi zestaw z tym
       samym wzorem to swiadomy wybor klienta. */
    let wKoszykuIds = new Set();

    /* Sztuki kazdego wzoru w koszyku (wszystkie pozycje, poza zestawem, ktory
       wysylka i tak najpierw zdejmie). Razem ze stanem z kafelka mowi, czy
       Shopify przyjmie jeszcze jedna sztuke - bez tego dodanie zestawu
       z ostatnia sztuka, ktora juz lezy w koszyku, padalo w calosci
       ogolnym zdaniem „maksymalna ilosc tego produktu" (zgloszenie
       1 pazdziernika 2026, Urban Mist ze stanem 1). */
    let iloscWKoszyku = new Map();

    /* Czy klient dodal juz w tej wizycie jakis zestaw (steruje dymkiem). */
    const KLUCZ_DODANY = 'dizz_zestaw_dodany';
    const zestawDodany = () => {
      try { return window.sessionStorage.getItem(KLUCZ_DODANY) === '1'; } catch (e) { return false; }
    };
    const oznaczDodany = () => {
      try { window.sessionStorage.setItem(KLUCZ_DODANY, '1'); } catch (e) { /* tryb prywatny */ }
    };

    const daneKafelka = (id) => kafelki.find((k) => k.dataset.sampleId === String(id));

    const bezSztuk = (id) => {
      const kafelek = daneKafelka(id);
      if (!kafelek || kafelek.dataset.sampleStock === undefined) return false;
      const stan = parseInt(kafelek.dataset.sampleStock, 10);
      const wKoszyku = iloscWKoszyku.get(String(id)) || 0;
      /* Tylko gdy sztuki zjadl koszyk - wyprzedany wzor (stan 0) ma swoj
         podpis „Chwilowo niedostepny" i nie moze dostac „Ostatnia w koszyku". */
      if (Number.isNaN(stan) || wKoszyku === 0) return false;
      return stan - wKoszyku <= 0;
    };

    const wariantDlaLiczby = (n) => warianty.find((w) => w.count === n) || null;

    const odswiez = () => {
      const zajete = wybor.filter(Boolean);
      const liczba = zajete.length;
      const wariant = wariantDlaLiczby(liczba);
      const pelny = maks > 0 && liczba >= maks;

      root.dataset.full = pelny ? 'true' : 'false';

      /* Kafelki: plakietka z ptaszkiem tylko na wybranych. */
      kafelki.forEach((kafelek) => {
        const wybrany = zajete.some((w) => w.id === kafelek.dataset.sampleId);
        kafelek.setAttribute('aria-pressed', wybrany ? 'true' : 'false');
        /* Wzor bez wolnej sztuki: wylaczony, ale juz wybrany da sie zdjac. */
        if (!kafelek.hasAttribute('data-sample-soldout')) {
          const brak = bezSztuk(kafelek.dataset.sampleId);
          kafelek.disabled = brak && !wybrany;
          kafelek.toggleAttribute('data-sample-nostock', brak);
          const plakietka = kafelek.querySelector('[data-sample-incart]');
          if (plakietka) {
            if (plakietka.dataset.labelInCart === undefined) plakietka.dataset.labelInCart = plakietka.textContent;
            plakietka.textContent = brak && plakietka.dataset.labelNostock ? plakietka.dataset.labelNostock : plakietka.dataset.labelInCart;
          }
        }
      });

      /* Sloty: miniatura, nazwa, krzyzyk i wlasciwosc pozycji zamowienia. */
      sloty.forEach((slot, i) => {
        const pozycja = wybor[i];
        const select = slot.querySelector('[data-slot-select]');
        const miniatura = slot.querySelector('.sample-slot__thumb');
        const krzyzyk = slot.querySelector('[data-slot-clear]');
        const wlasciwosc = slot.querySelector('[data-slot-property]');

        slot.dataset.filled = pozycja ? 'true' : 'false';
        if (select) {
          /* Wzor stojacy juz w INNYM okienku jest na tej liscie wyszarzony
             i podpisany numerem okienka. Wczesniej dal sie wybrac i po cichu
             znikal z tamtego okienka - klient liczyl trzy wzory, a zestaw
             mial dwa (zgloszone 25 wrzesnia 2026). */
          Array.from(select.options).forEach((opcja) => {
            if (!opcja.value) return;
            if (opcja.dataset.nazwa === undefined) {
              opcja.dataset.nazwa = opcja.textContent.trim();
              opcja.dataset.wyprzedana = opcja.disabled ? 'true' : 'false';
            }
            const gdzie = wybor.findIndex((w, j) => j !== i && w && w.id === opcja.value);
            const zajeta = gdzie !== -1;
            const brak = bezSztuk(opcja.value);
            const tutaj = pozycja && pozycja.id === opcja.value;
            opcja.disabled = zajeta || opcja.dataset.wyprzedana === 'true' || (brak && !tutaj);
            const dopiski = [];
            if (zajeta && napisy.chosen_in) dopiski.push(napisy.chosen_in.replace('__INDEX__', String(gdzie + 1)));
            if (brak && napisy.no_stock_option) dopiski.push(napisy.no_stock_option);
            else if (wKoszykuIds.has(opcja.value) && napisy.in_cart) dopiski.push(napisy.in_cart);
            opcja.textContent = dopiski.length
              ? `${opcja.dataset.nazwa} - ${dopiski.join(', ')}`
              : opcja.dataset.nazwa;
          });
          select.value = pozycja ? pozycja.id : '';
        }

        if (miniatura) {
          if (pozycja && pozycja.thumb) {
            miniatura.src = pozycja.thumb;
            miniatura.hidden = false;
          } else {
            miniatura.hidden = true;
            miniatura.removeAttribute('src');
          }
        }

        if (krzyzyk) krzyzyk.hidden = !pozycja;

        /* Wylaczone pole nie leci w zamowieniu, wiec pusty slot nie zostawia
           w koszyku wiersza "Probka nr 3: -". */
        if (wlasciwosc) {
          wlasciwosc.value = pozycja ? pozycja.name : '';
          wlasciwosc.disabled = !pozycja;
        }
      });

      /* Licznik - zielony dopiero od pierwszego wybranego wzoru (przy zerze
         kolor sukcesu sugerowal, ze cos juz jest gotowe; audyt 27.10.2026). */
      const licznikBox = root.querySelector('[data-sample-count]');
      if (licznikBox) licznikBox.classList.toggle('sample-count--pusty', liczba === 0);
      if (plakietka) plakietka.textContent = String(liczba);
      if (stan && napisy.state) {
        stan.textContent = napisy.state.replace('__COUNT__', String(liczba)).replace('__MAX__', String(maks));
      }
      /* Krotki licznik przy naglowku listy - w projekcie tylko na telefonie. */
      if (krotkiStan && napisy.short_state) {
        krotkiStan.textContent = napisy.short_state.replace('__COUNT__', String(liczba)).replace('__MAX__', String(maks));
      }
      if (cena) cena.textContent = wariant ? formatujKwote(wariant.price, napisy.money_format) : '';

      /* Przycisk zakupu */
      if (polaWariantu && wariant) polaWariantu.value = wariant.id;
      if (przycisk) przycisk.disabled = !wariant || wariant.available === false;
      if (napisPrzycisku) {
        if (wariant && napisy.cta) {
          napisPrzycisku.textContent = napisy.cta.replace(
            '__PRICE__',
            formatujKwote(wariant.price, napisy.money_format)
          );
        } else {
          napisPrzycisku.textContent = napisy.empty_cta || '';
        }
      }

      /* Pas komunikatu. Odslaniamy go dopiero, gdy jest co powiedziec. */
      if (pas) {
        let tytul = '';
        let tresc = '';

        /* Dymek z podpowiedzia "dodaj ten i skomponuj kolejny" tylko przy
           PIERWSZYM zestawie w wizycie - kto juz jeden dodal, wie, jak to
           dziala, wiec przy nastepnych zostaje sam tytul. */
        if (pelny) {
          tytul = napisy.full_title || '';
          if (!zestawDodany()) tresc = napisy.full_text || '';
        }

        if (tytul || tresc) {
          if (pasTytul) pasTytul.textContent = tytul;
          if (pasTresc) {
            pasTresc.textContent = tresc;
            pasTresc.hidden = !tresc;
          }
          pas.hidden = false;
        } else {
          pas.hidden = true;
        }
      }
    };

    const pierwszyWolny = () => wybor.findIndex((w) => w === null);

    const usunPoId = (id) => {
      const i = wybor.findIndex((w) => w && w.id === String(id));
      if (i > -1) wybor[i] = null;
      return i;
    };

    const dodaj = (id, nazwa, thumb) => {
      const wolny = pierwszyWolny();
      if (wolny === -1) return false;
      wybor[wolny] = { id: String(id), name: nazwa, thumb: thumb };
      return true;
    };

    /* Klik w kafelek: dodaje albo zdejmuje wzor z zestawu. */
    kafelki.forEach((kafelek) => {
      const id = kafelek.dataset.sampleId;
      const nazwa = kafelek.dataset.sampleName || '';
      const img = kafelek.querySelector('img');
      const thumb = img ? img.currentSrc || img.src : '';

      kafelek.addEventListener('click', () => {
        const juz = wybor.some((w) => w && w.id === String(id));
        if (juz) {
          usunPoId(id);
        } else if (!dodaj(id, nazwa, thumb)) {
          return;
        }
        odswiez();
      });
    });

    /* Wybor z listy w slocie. Ten sam wzor nie moze stac w dwoch slotach,
       wiec wczesniejsze wystapienie zwalniamy. */
    sloty.forEach((slot, i) => {
      const select = slot.querySelector('[data-slot-select]');
      const krzyzyk = slot.querySelector('[data-slot-clear]');

      if (select) {
        select.addEventListener('change', () => {
          const id = select.value;
          if (!id) {
            wybor[i] = null;
            odswiez();
            return;
          }

          usunPoId(id);

          const opcja = select.options[select.selectedIndex];
          const kafelek = daneKafelka(id);
          wybor[i] = {
            id: String(id),
            name: opcja ? (opcja.dataset.nazwa || opcja.textContent.trim()) : '',
            thumb: (opcja && opcja.dataset.thumb) || (kafelek && kafelek.querySelector('img') ? kafelek.querySelector('img').src : ''),
          };
          odswiez();
        });
      }

      if (krzyzyk) {
        krzyzyk.addEventListener('click', () => {
          wybor[i] = null;
          odswiez();
        });
      }
    });

    /* Skrocona siatka na telefonie. Na desktopie przycisk jest ukryty stylami,
       wiec stan zwiniecia nic tam nie zmienia. */
    if (wiecej) {
      root.dataset.collapsed = 'true';
      wiecej.addEventListener('click', () => {
        root.dataset.collapsed = root.dataset.collapsed === 'true' ? 'false' : 'true';
        wiecej.setAttribute('aria-expanded', root.dataset.collapsed === 'true' ? 'false' : 'true');
      });
    }

    /* ---------- tryb edycji: wzory i numer zestawu z adresu ---------- */

    /*
      Koszyk odsyla tu przez "Edytuj zestaw" z lista wybranych wzorow i numerem
      zestawu. Wzory wchodza na sloty jak po kliknieciu, a wysylka najpierw
      zdejmuje stary zestaw z koszyka, zeby nie zostaly dwa.
    */
    const adres = new URL(window.location.href);
    let edytowanyZestaw = adres.searchParams.get('edycja') || '';
    const napisCta = napisy.cta;
    const wstepne = (adres.searchParams.get('wzory') || '').split(',').filter(Boolean);

    wstepne.forEach((id) => {
      const kafelek = daneKafelka(id);
      if (!kafelek || kafelek.disabled) return;
      const img = kafelek.querySelector('img');
      dodaj(id, kafelek.dataset.sampleName || '', img ? img.currentSrc || img.src : '');
    });

    if (edytowanyZestaw && napisy.update_cta) napisy.cta = napisy.update_cta;

    /* ---------- wysylka do koszyka: nosnik plus probki ---------- */

    /*
      Zestaw to 1 + N pozycji koszyka, a zwykly formularz produktu wysyla jedna,
      wiec wysylke przejmuje skrypt. Nosnik niesie cene (wariant = liczba
      wzorow) i czytelne wlasciwosci "Probka nr N" dla obslugi; probki wchodza
      jako wlasne pozycje po jednej sztuce, zeby zdjac stan i trafic do
      raportow. Rabat automatyczny w sklepie zeruje je, gdy obok stoi nosnik.

      Wlasciwosci z podkresleniem sa dla koszyka niewidoczne dla klienta:
      numer zestawu wiaze pozycje ze soba, rola odroznia nosnik od probki, a
      lista wariantow pozwala stronie koszyka przeliczyc nosnik w dol.
    */
    const formularz = root.querySelector('form.sample-set__form');

    const pozycjeDoKoszyka = (numerZestawu) => {
      const zajete = wybor.filter(Boolean);
      const wariant = wariantDlaLiczby(zajete.length);
      if (!wariant) return null;

      const wlasciwosciNosnika = {};
      root.querySelectorAll('[data-slot-property]').forEach((pole) => {
        if (!pole.disabled && pole.value) {
          const klucz = pole.name.replace(/^properties\[/, '').replace(/\]$/, '');
          wlasciwosciNosnika[klucz] = pole.value;
        }
      });
      wlasciwosciNosnika._zestaw = numerZestawu;
      wlasciwosciNosnika._zestaw_rola = 'nosnik';
      wlasciwosciNosnika._zestaw_warianty = warianty
        .slice()
        .sort((a, b) => a.count - b.count)
        .map((w) => w.id)
        .join(',');

      /* Nosnik idzie w ilosci rownej liczbie wzorow: wariant ma cene za sztuke,
         a rabat "kup 1 nosnik, 1 probka gratis" zeruje tyle probek, ile jest
         sztuk nosnika. Probka bez nosnika kosztuje normalnie. */
      const pozycje = [{ id: wariant.id, quantity: zajete.length, properties: wlasciwosciNosnika }];
      zajete.forEach((w) => {
        pozycje.push({
          id: Number(w.id),
          quantity: 1,
          properties: { _zestaw: numerZestawu, _zestaw_rola: 'probka' },
        });
      });
      return pozycje;
    };

    const zdejmijStaryZestaw = async (numer) => {
      if (!numer) return;
      const koszyk = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const doZdjecia = (koszyk.items || []).filter((p) => p.properties && p.properties._zestaw === numer);
      if (!doZdjecia.length) return;
      /* Jednym zadaniem: po pojedynczej zmianie Shopify uniewaznia klucze
         pozostalych pozycji i kolejne wywolanie pada z bledem 400. */
      const updates = {};
      doZdjecia.forEach((p) => { updates[p.key] = 0; });
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      });
    };

    const pokazBlad = (tekst) => {
      if (window.wishlistBar && typeof window.wishlistBar.show === 'function') {
        window.wishlistBar.show({ text: tekst, error: true });
      } else {
        window.alert(tekst);
      }
    };

    if (formularz && przycisk) {
      formularz.addEventListener('submit', async (zdarzenie) => {
        if (!window.fetch) return; /* bez fetch idzie zwykly formularz: sam nosnik */
        zdarzenie.preventDefault();
        /* Szuflada koszyka nasluchuje wysylki KAZDEGO formularza /cart/add na
           dokumencie. Bez zatrzymania babelkowania dolozylaby sam nosnik jako
           zwykly produkt - w koszyku stawala wtedy druga, osierocona pozycja
           „Zestaw probek" obok karty zestawu. */
        zdarzenie.stopPropagation();

        /* Wzor wybrany, zanim koszyk zdazyl sie wczytac (albo z adresu), a jego
           ostatnia sztuka juz lezy w koszyku: mowimy ktory, zamiast wysylac
           zestaw, ktory Shopify odrzuci w calosci. */
        const bezSztukWybrany = wybor.find((w) => w && bezSztuk(w.id));
        if (bezSztukWybrany) {
          pokazBlad((napisy.no_stock_error || napisy.add_error || '').replace('__NAME__', bezSztukWybrany.name));
          return;
        }

        const numerZestawu = `zestaw-${Date.now().toString(36)}`;
        const pozycje = pozycjeDoKoszyka(numerZestawu);
        if (!pozycje) return;

        const dodaj = async () => {
          przycisk.disabled = true;
          root.dataset.sending = 'true';

          try {
            await zdejmijStaryZestaw(edytowanyZestaw);
            const odpowiedz = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: pozycje }),
            });
            if (!odpowiedz.ok) {
              /* 422 niesie powod po ludzku (np. ostatnia sztuka probki jest juz
                 w poprzednim zestawie) - lepszy niz ogolne "nie udalo sie". */
              let powod = '';
              try { powod = (await odpowiedz.json()).description || ''; } catch (e) { /* brak tresci */ }
              const blad = new Error(powod);
              blad.dlaKlienta = true;
              throw blad;
            }
            /* Zestaw jest w koszyku, wiec okienka wracaja do pustych - bez tego
               komplet blokowal wybor i drugiego zestawu nie dalo sie ulozyc.
               Po edycji konfigurator wraca do zwyklego trybu (nowy zestaw),
               inaczej kolejne dodanie zdjeloby z koszyka ten poprawiony. */
            oznaczDodany();
            wybor.fill(null);
            if (edytowanyZestaw) {
              edytowanyZestaw = '';
              napisy.cta = napisCta;
              adres.searchParams.delete('edycja');
              adres.searchParams.delete('wzory');
              window.history.replaceState(window.history.state, '', adres.pathname + adres.search + adres.hash);
            }
            odswiez();
            /* Koszyk tego sklepu to szuflada - i ona umie pokazac zestaw tak
               samo jak strona koszyka. Klient zostaje na konfiguratorze, wiec
               dolozenie drugiego zestawu to jedno klikniecie. Bez szuflady
               (brak sekcji) zostaje przejscie na strone koszyka. */
            oznaczWKoszyku();
            if (window.dizzKoszyk) {
              await window.dizzKoszyk.otworz({ odswiez: true });
              root.dataset.sending = 'false';
              przycisk.disabled = false;
              return;
            }
            window.location.assign(napisy.cart_url || '/cart');
          } catch (e) {
            root.dataset.sending = 'false';
            przycisk.disabled = false;
            pokazBlad((e && e.dlaKlienta && e.message) || napisy.add_error || '');
          }
        };

        /* Zestaw idzie do koszyka od razu - o obszar dowozu pyta dopiero
           drugi krok szuflady koszyka, na drodze do kasy. */
        dodaj();
      });
    }

    /* Wejscie bez trybu edycji, a w koszyku stoi zestaw z wolnym miejscem:
       konfigurator otwiera TEN zestaw (jego wzory w okienkach, wysylka go
       podmienia), zamiast startowac od pustych okienek - klient z jednym
       wzorem w koszyku widzial „0 z 5" i skladal drugi, osobny zestaw.
       Ten sam wybor zestawu co przy szybkiej probce na stronie panelu:
       najnowszy (Shopify oddaje najnowsze pozycje na poczatku listy).
       Tylko raz, przy wejsciu - pozniejsze zmiany koszyka nie nadpisuja
       tego, co klient uklada. */
    let zestawWczytany = false;
    const wczytajZestawZKoszyka = (items) => {
      if (zestawWczytany) return;
      zestawWczytany = true;
      if (edytowanyZestaw) return;
      const nosniki = items.filter((p) => p.properties && p.properties._zestaw_rola === 'nosnik' && p.properties._zestaw);
      for (let i = 0; i < nosniki.length; i += 1) {
        const numer = nosniki[i].properties._zestaw;
        const probki = items
          .filter((p) => p.properties && p.properties._zestaw === numer && p.properties._zestaw_rola === 'probka')
          .reverse();
        if (!probki.length || probki.length >= wybor.length) continue;

        /* Wzory z adresu (np. „Porownaj wszystkie probki" ze strony panelu)
           dochodza do zestawu za jego wzorami, o ile jest miejsce. */
        const zAdresu = wybor.filter(Boolean);
        wybor.fill(null);
        probki.forEach((p) => {
          const kafelek = daneKafelka(String(p.variant_id));
          const img = kafelek ? kafelek.querySelector('img') : null;
          dodaj(String(p.variant_id), kafelek ? kafelek.dataset.sampleName || '' : p.product_title, img ? img.currentSrc || img.src : p.image || '');
        });
        zAdresu.forEach((w) => {
          if (!wybor.some((x) => x && x.id === w.id)) dodaj(w.id, w.name, w.thumb);
        });
        edytowanyZestaw = numer;
        if (napisy.update_cta) napisy.cta = napisy.update_cta;
        return;
      }
    };

    /* Plakietka „W koszyku" na wzorach, ktore sa juz w jakims zestawie
       w koszyku. Zrodlem jest /cart.js, bo zestaw dochodzi i znika bez
       przeladowania strony (szuflada oglasza to zdarzeniem koszyk:zmiana). */
    const oznaczWKoszyku = async () => {
      let koszyk;
      try {
        koszyk = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      } catch (e) {
        return;
      }
      const wKoszyku = new Set(
        (koszyk.items || [])
          .filter((p) => p.properties && p.properties._zestaw_rola === 'probka')
          .map((p) => String(p.variant_id)),
      );
      wKoszykuIds = wKoszyku;
      wczytajZestawZKoszyka(koszyk.items || []);
      const ilosci = new Map();
      (koszyk.items || []).forEach((p) => {
        if (edytowanyZestaw && p.properties && p.properties._zestaw === edytowanyZestaw) return;
        const id = String(p.variant_id);
        ilosci.set(id, (ilosci.get(id) || 0) + p.quantity);
      });
      iloscWKoszyku = ilosci;
      odswiez();
      kafelki.forEach((kafel) => {
        const jest = wKoszyku.has(kafel.dataset.sampleId) || bezSztuk(kafel.dataset.sampleId);
        kafel.toggleAttribute('data-in-cart', jest);
        const plakietka = kafel.querySelector('[data-sample-incart]');
        if (plakietka) plakietka.hidden = !jest;
      });
    };
    document.addEventListener('koszyk:zmiana', oznaczWKoszyku);
    oznaczWKoszyku();

    odswiez();
  };

  const init = () => {
    document.querySelectorAll('[data-sample-set]').forEach(initSampleSet);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Edytor motywu podmienia HTML sekcji bez odswiezenia strony. */
  document.addEventListener('shopify:section:load', init);
})();
